import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseResetPasswordComponent } from './reset-password/base-reset-password.component';
import { BaseLoginService } from '../../services/login/base-login.service';
import { AmorphicService } from '../../services/amorphic/amorphic.service';
import { LoginComponentScreen } from '../../classes/LoginComponentScreen';
import { BaseLoginComponent } from './login/base-login.component';
import { BaseRegisterComponent } from './register/base-register.component';

@Component({
  moduleId: module.id,
  selector: 'base-login-container',
  templateUrl: './base-login-container.component.html',
})
export class BaseLoginContainerComponent implements OnInit {
  @ViewChild('registerComponent') registerComponent: BaseRegisterComponent;
  @ViewChild('resetPasswordComponent') resetPasswordComponent: BaseResetPasswordComponent;
  @ViewChild('loginComponent') loginComponent: BaseLoginComponent;

  loginComponentScreen: { [s: number]: string } = LoginComponentScreen;
  showComponent: LoginComponentScreen = LoginComponentScreen['Login'];
  controller;
  errorMessage: string;
  continueRegister: boolean = false;
  withNewEmail: boolean = false;

  constructor(
    private amorphicService: AmorphicService,
    private loginService: BaseLoginService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.controller = amorphicService.controller;
  }

  ngOnInit(): void {
    this.route.fragment.subscribe((fragment) => {
      const screen = LoginComponentScreen[fragment];
      this.clearAuthFields();
      if (screen === LoginComponentScreen['Register'] || screen === LoginComponentScreen['RegisterLifeBridge']) {
        this.showComponent = LoginComponentScreen['Register'];
      } else if (screen === LoginComponentScreen['Reset']) {
        this.showComponent = LoginComponentScreen['Reset'];
      } else if (screen === LoginComponentScreen['NewEmail']) {
        this.showComponent = LoginComponentScreen['Login'];
        this.withNewEmail = true;
      } else {
        this.showComponent = LoginComponentScreen['Login'];
      }
    });
  }

  clearAuthFields(): void {
    this.controller.password = '';
    this.controller.firstName = '';
    this.controller.lastName = '';
    this.controller.confirmPassword = '';
    this.controller.newPassword = '';
  }
}
